import type { ComponentChildren } from "preact";

interface PlayerRibbonProps {
  className?: string;
  headerClassName?: string;
  toolbarClassName?: string;
  toolbar: ComponentChildren;
  headerAfter?: ComponentChildren;
  children?: ComponentChildren;
}

function classList(...names: Array<string | undefined>): string {
  return names.filter(Boolean).join(" ");
}

export function PlayerRibbon({
  className,
  headerClassName,
  toolbarClassName,
  toolbar,
  headerAfter,
  children,
}: PlayerRibbonProps) {
  return (
    <div class={classList("player-ribbon", className)}>
      <header
        class={classList("player-ribbon__header", headerClassName)}
        aria-label="Game controls"
      >
        <div class={classList("player-ribbon__toolbar", toolbarClassName)}>
          {toolbar}
        </div>
        {headerAfter}
      </header>
      {children}
    </div>
  );
}
